<div class="event" [class.compact]="compact" [class.done]="event.done != null">
  <div *ngIf="!compact" (click)="checkboxClicked()" class="checkbox"></div>
  <div *ngIf="!compact" class="edit-icon" [matMenuTriggerFor]="eventActions">
    <span class="iconify" data-icon="eva:more-vertical-fill"></span>
  </div>

  <div class="text" [class.cursor-pointer]="compact" [class.leading-4]="compact" (click)="editEvent()">
    <div class="text-xs text-gray-600 relative pl-8 hover:underline">

      <div *ngIf="event.cooperation.customer.logo" [style.background-image]="'url(' + event.cooperation.customer.logo.filename + ')'" class="h-6 w-6 bg-gray-200 rounded-full bg-contain inline-block mr-1 absolute left-0 ml-1 vertical-center bg-no-repeat bg-center"></div>
      <span class="iconify inline-block text-sm mr-1" data-icon="fluent:handshake-20-regular"></span>

      <span (click)="$event.stopPropagation()" class="cursor-pointer" *ngIf="!compact" [routerLink]="['/cooperations', event.cooperation.id]">{{ event.cooperation.name }} &bull;</span>

      <span class="font-bold">{{ event.cooperation.customer.companyDisplayName ? event.cooperation.customer.companyDisplayName : event.cooperation.customer.companyName }}</span>
    </div>
    <div class="font-bold cursor-pointer hover:underline" (click)="editEvent();$event.stopPropagation()" [class.text-lg]="!compact" [class.text-base]="compact">
      {{ event.title }}
    </div>
    <div>
      <span *ngIf="event.cpm > 0" class="text-xs font-bold text-gray-700">
        TKP {{ event.cpm | currency: 'EUR' }}
      </span>
      {{ event.deadline | formatDate: 'ddd, DD.MM.YYYY' }}
      <span class="inline-block mr-1" *ngIf="!event.fullday">{{ event.deadline | date: 'HH:mm' }}</span>

      <div class="inline-block" *ngIf="!event.done && !compact">
        <span *ngIf="days > 0;else overdue">
          (<span *ngIf="days == 1">morgen</span>
          <span *ngIf="days == 2">übermorgen</span>
          <span *ngIf="days >= 3">in {{ days }} Tagen</span>)
        </span>
      </div>


      <ng-template #overdue>
        (<span *ngIf="diff < 0">
          <span class="text-red-500 font-bold">überfällig!</span>
        </span>
        <span *ngIf="diff > 0">
          heute
        </span>)
      </ng-template>
    </div>
  </div>
  <div class="absolute bottom-0 right-0 pb-1 text-gray-400">
    <div *ngIf="event.briefing" class="inline-block pr-1" title="Briefing hinterlegt">
      <span class="iconify" data-icon="akar-icons:info"></span>
    </div>
    <div *ngIf="event.medias?.length > 0" class="inline-block pr-1" title="Anhänge hinterlegt">
      <span class="iconify" data-icon="carbon:attachment"></span>
    </div>
    <div *ngIf="event.coupon" class="inline-block pr-1" title="Gutscheincode hinterlegt">
      <span class="iconify" data-icon="bx:bxs-coupon"></span>
    </div>
  </div>
</div>

<mat-menu #eventActions>
  <div (click)="editEvent()" class="outline-none cursor-pointer" mat-menu-item>Bearbeiten</div>
  <div *ngIf="event.postponement" class="outline-none cursor-pointer" mat-menu-item>Termin verschieben</div>
  <div (click)="delete()" class="outline-none cursor-pointer" mat-menu-item>
    <span class="text-red-500">Termin löschen</span>
  </div>
</mat-menu>
